/**
 * Combines the conflicts-related admin pages under one nav tab: how much the request page is
 * used (ConflictStats), then the two settings pages: where conflict
 * check requests get routed (AdminConflictRouting) and the standalone /conflicts
 * request page's copy/layout (AdminConflictsPage). Each keeps its own Firestore
 * subscription and save action — this is pure composition, nothing shared between them.
 */

import ConflictStats from './ConflictStats';
import AdminConflictRouting from './AdminConflictRouting';
import AdminConflictsPage from './AdminConflictsPage';

export default function AdminConflicts() {
  return (
    <div className="space-y-6">
      {/* Usage first: the question "is anyone using this" comes before "where does it go". */}
      <ConflictStats />
      <AdminConflictRouting />
      <AdminConflictsPage />
    </div>
  );
}
